import { render } from "./UpdatePage.vue?vue&type=template&id=4e08bc02&scoped=true"
import script from "./UpdatePage.vue?vue&type=script&lang=js"
export * from "./UpdatePage.vue?vue&type=script&lang=js"

import "./UpdatePage.vue?vue&type=style&index=0&id=4e08bc02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e08bc02"]])

export default __exports__